/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    RATING_LIMITS_SET_HIGHLIGHT_POSITION,
    RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED,
    RATING_LIMITS_SET_OPTION_LIMIT_LIST,
    RATING_LIMITS_SET_SELECTED_OPTION_LIST,
    RATING_LIMITS_SET_VERTICAL_LIMIT,
    RATING_LIMITS_SET_VERTICAL_POSITION,
} from './setratinglimits.types';

export const ratingLimitsSetVerticalPositionAction = (
    verticalPosition: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: RATING_LIMITS_SET_VERTICAL_POSITION,
    payload: { verticalPosition },
});

export const ratingLimitsSetVerticalLimitAction = (
    verticalLimit: number,
): TivoPayloadAction<{
    verticalLimit: number;
}> => ({
    type: RATING_LIMITS_SET_VERTICAL_LIMIT,
    payload: {
        verticalLimit,
    },
});

export const ratingLimitsSetSelectedOptionListAction = (
    selectedOptionList: number[],
): TivoPayloadAction<{ selectedOptionList: number[] }> => ({
    type: RATING_LIMITS_SET_SELECTED_OPTION_LIST,
    payload: { selectedOptionList },
});

export const ratingLimitsSetOptionLimitListAction = (
    optionLimitList: number[],
): TivoPayloadAction<{ optionLimitList: number[] }> => ({
    type: RATING_LIMITS_SET_OPTION_LIMIT_LIST,
    payload: { optionLimitList },
});

export const ratingLimitsSetIsGhostModeEnabled = (
    isGhostModeEnabled: boolean,
): TivoPayloadAction<{ isGhostModeEnabled: boolean }> => ({
    type: RATING_LIMITS_SET_IS_GHOST_MODE_ENABLED,
    payload: {
        isGhostModeEnabled,
    },
});

export const ratigLimitSetFocusedPositionAction = (
    verticalPosition: number,
    isGhostModeEnabled: boolean,
): TivoPayloadAction<{
    verticalPosition: number;
    isGhostModeEnabled: boolean;
}> => ({
    type: RATING_LIMITS_SET_HIGHLIGHT_POSITION,
    payload: {
        verticalPosition,
        isGhostModeEnabled,
    },
});
